import UISelect from 'UIComponents/input/UISelect';
import UITruncateString from 'UIComponents/text/UITruncateString';
import { Text } from 'foundations-components/components/Text';
import { propertyLabelTranslator } from 'property-translator/propertyTranslator';
import { setDealStageMapping } from '../../../actions/WizardActions';
import { useDispatch } from 'react-redux';
import { getDealStageOptions } from '../../../utils/wizardUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CategoryMappingTableRow = ({
  forecastCategory,
  dealStageMapping,
  dealStageReadOnly,
  pipelineId
}) => {
  const dispatch = useDispatch();
  return /*#__PURE__*/_jsxs("tr", {
    children: [/*#__PURE__*/_jsx("td", {
      children: /*#__PURE__*/_jsxs(UITruncateString, {
        "data-test-id": 'forecast-category-label',
        children: [propertyLabelTranslator(forecastCategory.label), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Text, {
          as: "small",
          children: propertyLabelTranslator(forecastCategory.description)
        })]
      })
    }), /*#__PURE__*/_jsx("td", {
      children: /*#__PURE__*/_jsx(UISelect, {
        multi: true,
        "data-test-id": 'deal-stage-select',
        anchorType: "button",
        readOnly: dealStageReadOnly,
        placeholder: "",
        options: getDealStageOptions(dealStageMapping.allDealStages),
        value: dealStageMapping.dealStageByForecastCategory[forecastCategory.value],
        onChange: ({
          target: {
            value: newMappings
          }
        }) => {
          dispatch(setDealStageMapping(pipelineId, true, forecastCategory.value, newMappings));
        }
      })
    })]
  });
};
export default CategoryMappingTableRow;